import { Box, Stack, Typography, TextField, Button, Link } from '@mui/material';
import { Navigate, useNavigate } from 'react-router-dom';
import { useUserAuth } from '../context/auth_context';
import FirebaseAuth from '../firebase/auth';
import { showToast } from '../utils/toast';
import Logo from '../assets/images/thumbnail_80x80.png';
import { IS_DEMO } from '../utils/config';

export default function Login() {
  const navigate = useNavigate();

  const { user } = useUserAuth();

  async function handleSubmit(e) {
    e.preventDefault();

    let values = {};
    Array.from(e.target).forEach(({ name, value }) => {
      if (name) {
        values[name] = value;
      }
    });

    if (!values.email || !values.password) {
      return showToast({
        type: 'error',
        message: 'Please enter your auth credentials'
      });
    }

    try {
      await FirebaseAuth.logInWithEmailAndPassword(values.email, values.password);
      navigate('/contents');
    } catch (error) {
      if ('message' in error) {
        showToast({
          type: 'error',
          message: error.message.replace('Firebase: ', '')
        });
      } else {
        showToast({ type: 'error', message: error });
      }
    }
  }

  if (user === 'loading') {
    return <div></div>;
  }
  if (user?.uid) {
    return <Navigate to="/contents" />;
  }

  return (
    <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
      <Box width="100%" height="100vh" display="flex" alignItems="center" justifyContent="center">
        <Stack maxWidth="400px" width="100%" gap={3} alignItems="center" p="15px">
          <Box
            component="img"
            src={Logo}
            alt="Logo"
            sx={{ width: 80, height: 80, borderRadius: '50%' }}
          />
          <Typography fontWeight={400} variant="h3">
            Admin Panel
          </Typography>
          <TextField variant="outlined" fullWidth label="Email" name="email" id="email" />
          <TextField variant="outlined" fullWidth label="Password" name="password" id="password" />
          {/* Demo Credentials Note */}
          {IS_DEMO && (
            <Box
              sx={{
                p: 2,
                bgcolor: 'background.paper',
                border: '1px dashed grey',
                borderRadius: 1,
                width: '100%'
              }}>
              <Typography variant="subtitle2" color="primary">
                Demo Credentials:
              </Typography>
              <Typography variant="body2">
                Email: <strong>snory@bluetouch.dev</strong>
              </Typography>
              <Typography variant="body2">
                Password: <strong>Test@123</strong>
              </Typography>
              <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 1 }}>
                Note: This is a demo version.
              </Typography>
            </Box>
          )}
          <Button type="submit" size="large" fullWidth variant="contained">
            Log in
          </Button>
          <Link href="/forget-password">
            <Typography variant="body2">Forget Password</Typography>
          </Link>
          <Box sx={{ height: '10vh' }} />
        </Stack>
      </Box>
    </Box>
  );
}
